import React from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import NavBar from "../Containers/NavBar";
import { PlatformStatusBanner } from "../Alerts/PlatformStatusBanner";
import RebrandBanner from "../Alerts/RebrandBanner";
import { useRebrandBanner } from "../../hooks/useRebrandBanner";
import { OnboardingChecklistProvider } from "../../contexts/OnboardingChecklistContext";

const getMainStyles = ({
  isLogged,
  rebrandBannerOffsetPx,
  totalTopOffsetPx,
}) => {
  if (isLogged) {
    return {
      minHeight: `calc(100vh - ${totalTopOffsetPx}px)`,
      paddingTop: `${rebrandBannerOffsetPx}px`,
    };
  }
  return {
    minHeight: `calc(100vh - ${rebrandBannerOffsetPx}px)`,
    paddingTop: `${rebrandBannerOffsetPx}px`,
  };
};

const GeneralLayout = ({ children, isLogged }) => {
  const { rebrandBannerOffsetPx, totalTopOffsetPx } = useRebrandBanner();

  return isLogged ? (
    <OnboardingChecklistProvider>
      <Box sx={{ display: "flex" }}>
        <RebrandBanner />
        <React.Fragment>
          <PlatformStatusBanner />
          <NavBar />
        </React.Fragment>
        <Box
          component="main"
          sx={{
            width: "100%",
            ...getMainStyles({
              isLogged,
              rebrandBannerOffsetPx,
              totalTopOffsetPx,
            }),
          }}
        >
          <Toolbar />
          {children}
        </Box>
      </Box>
    </OnboardingChecklistProvider>
  ) : (
    <Box sx={{ display: "flex" }}>
      <RebrandBanner />
      <Box
        component="main"
        sx={{
          width: "100%",
          ...getMainStyles({
            isLogged,
            rebrandBannerOffsetPx,
            totalTopOffsetPx,
          }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default GeneralLayout;
